import { useStorage } from '@/utils/storage.js';
import { useDynamicRoutes } from '@/router/routes.js'

/* 引入进度条插件 */
import NProgress from 'nprogress'
/* 引用进度条插件样式*/
import 'nprogress/nprogress.css'
 
import router from './index.js' 

NProgress.configure({ showSpinner: true });

const updateRoutes = () => {
	router.removeRoute('__home')
	router.addRoute(useDynamicRoutes())
}

// 路由白名单
const whiteList = ['/login']

// 路由守卫，实现未登录的用户他跳转到login页面
router.beforeEach((to, from, next) => {
    // 进度条开始
    NProgress.start()
	
	/* 路由发生变化修改页面title */
	if (to.meta.title) {
		document.title = `${to.meta.title} - ${import.meta.env.VITE_APP_TITLE}`
	}
	else {
		document.title = `${import.meta.env.VITE_APP_TITLE}`
	}
	
	updateRoutes()
	
	// token 存在，并且有效 直接进入
	const token = useStorage('local').get('user-token')
	
	// 如果是已经登录状态，直接进入
	if(to.path == '/login' && !!token) {
		next({ path: '/home' });
		return
	}
	
	// 在白名单中的路由  
	if(whiteList.indexOf(to.path) >= 0) {
	    next()
	    return
	}
	
	if(!token) {
		// 进入登录页
		next({ path: '/login', query: { redirectTo: to.path } })
		return
	}
	
	next()
})

router.afterEach((to) => { 
    // 进度条结束
    NProgress.done()
})